import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "pretty-json" }
const _hoisted_2 = { class: "key" }
const _hoisted_3 = {
  key: 1,
  class: "pretty-json pretty-json--nested"
}
const _hoisted_4 = { class: "key" }
const _hoisted_5 = {
  key: 0,
  class: "pretty-json pretty-json--nested"
}
const _hoisted_6 = { class: "value" }
const _hoisted_7 = {
  key: 1,
  class: "value"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, ([k, v]) => {
      return (_openBlock(), _createElementBlock("li", { key: k }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(k) + ": ", 1),
        (Array.isArray(v))
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((v as unknown[]), (item) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "chip",
                key: String(item)
              }, _toDisplayString(item), 1))
            }), 128))
          : (typeof v === 'object' && v !== null)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(v), ([nk, nv]) => {
                  return (_openBlock(), _createElementBlock("li", { key: nk }, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(nk) + ":", 1),
                    _createTextVNode(" " + _toDisplayString(nv), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.nestedPrimitives)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(v), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(v), 1))
              ], 64))
      ]))
    }), 128))
  ]))
}